<template>
  <div class="room gas-clamp">
    <RefreshBlock @refreshData="refreshData"></RefreshBlock>
    <div class="main-cable" v-loading="loading">
      <div class="cable-title">
        <h2>下游气夹</h2>
      </div>
      <div class="cable-main">
        <div class="legend">
          <div class="sensor1">排气夹</div>
          <div class="sensor2">进气夹</div>
          <div class="sensor-source">数据来源: WINCC</div>
        </div>
        <!-- <div class="legend-station">
                <i class="iconfont iconshebei"></i>
                <span>除湿机</span>
              </div> -->
        <!-- <div class="legend-right">
                <div class="running">设备运行</div>
                <div class="stopped">设备停止</div>
                <div class="default">数据中断</div>
              </div> -->
        <div class="dir left-dir">
          <i class="iconfont icongeo-arrow-left"></i>
          <span class="dir-text">华坪</span>
        </div>
        <div class="dir right-dir">
          <i class="iconfont icongeo-arrow-left-copy"></i>
          <span class="dir-text">丽江</span>
        </div>
        <div class="cable-img">
          <el-tooltip class="station-block station-block-anchor-left" content="华坪下游锚室" effect="light" placement="top">
            <router-link class="iconfont iconshebei" to="/jinshajiang/stationAnchorPlc/huaping"></router-link>
          </el-tooltip>
          <div class="stati anchor-left">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{
                  assembleTooltip_dehumidifier(
                    "华坪下游锚室",
                    humidityTooltipErrorAnchorHuapingDown,
                    humidityAllowedMaxAnchorHuapingDown,
                    runningAnchorHuapingDown,
                    malfunctionAnchorHuapingDown
                  )
                }}
              </div>
              <div :class="errorAnchorHuapingDown" class="state-info right-pos" @dblclick="hrefToStation('')">
                <p>华坪下游锚室</p>
                <p>
                  <span>{{ humidityAnchorHuapingDown | toFixed }}% {{ temperatureAnchorHuapingDown | toFixed }}°C</span>
                  <span :class="runningClassAnchorHuapingDown" class="valve-sign"></span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <el-tooltip class="station-block station-block-anchor-right" content="丽江下游锚室" effect="light" placement="top">
            <router-link class="iconfont iconshebei" to="/jinshajiang/stationAnchorPlc/Lijiang"></router-link>
          </el-tooltip>
          <div class="stati anchor-right">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{
                  assembleTooltip_dehumidifier(
                    "丽江下游锚室",
                    humidityTooltipErrorAnchorLijiangDown,
                    humidityAllowedMaxAnchorLijiangDown,
                    runningAnchorLijiangDown,
                    malfunctionAnchorLijiangDown
                  )
                }}
              </div>
              <div :class="errorAnchorLijiangDown" class="state-info left-pos" @dblclick="hrefToStation('')">
                <p>丽江下游锚室</p>
                <p>
                  <span>{{ humidityAnchorLijiangDown | toFixed }}% {{ temperatureAnchorLijiangDown | toFixed }}°C</span>
                  <span :class="runningClassAnchorLijiangDown" class="valve-sign"></span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <el-tooltip class="station-block station-block-saddle-left" content="华坪下游鞍室" effect="light" placement="top">
            <router-link class="iconfont iconshebei" to="/jinshajiang/stationSaddlePlc/huaping"></router-link>
          </el-tooltip>
          <div class="stati saddle-left">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{
                  assembleTooltip_dehumidifier(
                    "华坪下游鞍室",
                    humidityTooltipErrorSaddleHuapingDown,
                    humidityAllowedMaxSaddleHuapingDown,
                    runningSaddleHuapingDown,
                    malfunctionSaddleHuapingDown
                  )
                }}
              </div>
              <div :class="errorSaddleHuapingDown" class="state-info bottom-right-pos" @dblclick="hrefToStation('')">
                <p>华坪下游鞍室</p>
                <p>
                  <span>{{ humiditySaddleHuapingDown | toFixed }}% {{ temperatureSaddleHuapingDown | toFixed }}°C</span>
                  <span :class="runningClassSaddleHuapingDown" class="valve-sign"></span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <el-tooltip class="station-block station-block-saddle-right" content="丽江下游鞍室" effect="light" placement="top">
            <router-link class="iconfont iconshebei" to="/jinshajiang/stationSaddlePlc/Lijiang"></router-link>
          </el-tooltip>
          <div class="stati saddle-right">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{
                  assembleTooltip_dehumidifier(
                    "丽江下游鞍室",
                    humidityTooltipErrorSaddleLijiangDown,
                    humidityAllowedMaxSaddleLijiangDown,
                    runningSaddleLijiangDown,
                    malfunctionSaddleLijiangDown
                  )
                }}
              </div>
              <div :class="errorSaddleLijiangDown" class="state-info bottom-left-pos" @dblclick="hrefToStation('')">
                <p>丽江下游鞍室</p>
                <p>
                  <span>{{ humiditySaddleLijiangDown | toFixed }}% {{ temperatureSaddleLijiangDown | toFixed }}°C</span>
                  <span :class="runningClassSaddleLijiangDown" class="valve-sign"></span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 ex1">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorCW2, humidityAllowedMaxCW2) }}
              </div>
              <div :class="errorCW2" class="state-info right-pos">
                <p>CW2传感器*</p>
                <p>
                  <span
                    >{{ humidityCW2 | toFixed }}% {{ temperatureCW2 | toFixed }}°C <br />
                    {{ pressureCW2 | toFixed }}Pa</span
                  >
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor2 ex2">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorJW2, humidityAllowedMaxJW2) }}
              </div>
              <div :class="errorJW2" class="state-info top-right-pos">
                <p>JW2传感器*</p>
                <p>
                  <span
                    >{{ humidityJW2 | toFixed }}% {{ temperatureJW2 | toFixed }}°C <br />
                    {{ pressureJW2 | toFixed }}Pa</span
                  >
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 ex3">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorCW4, humidityAllowedMaxCW4) }}
              </div>
              <div :class="errorCW4" class="state-info right-pos">
                <p>CW4传感器*</p>
                <p>
                  <span
                    >{{ humidityCW4 | toFixed }}% {{ temperatureCW4 | toFixed }}°C <br />
                    {{ pressureCW4 | toFixed }}Pa</span
                  >
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 ex4">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorCM2, humidityAllowedMaxCM2) }}
              </div>
              <div :class="errorCM2" class="state-info left-pos">
                <p>CM2传感器</p>
                <p>
                  <span
                    >{{ humidityCM2 | toFixed }}% {{ temperatureCM2 | toFixed }}°C <br />
                    {{ pressureCM2 | toFixed }}Pa</span
                  >
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor2 ex5">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorJM2, humidityAllowedMaxJM2) }}
              </div>
              <div :class="errorJM2" class="state-info top-right-pos">
                <p>JM2传感器*</p>
                <p>
                  <span
                    >{{ humidityJM2 | toFixed }}% {{ temperatureJM2 | toFixed }}°C <br />
                    {{ pressureJM2 | toFixed }}Pa</span
                  >
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 ex6">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorCM4, humidityAllowedMaxCM4) }}
              </div>
              <div :class="errorCM4" class="state-info left-pos">
                <p>CM4传感器*</p>
                <p>
                  <span
                    >{{ humidityCM4 | toFixed }}% {{ temperatureCM4 | toFixed }}°C <br />
                    {{ pressureCM4 | toFixed }}Pa</span
                  >
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor2 ex7">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorJM4, humidityAllowedMaxJM4) }}
              </div>
              <div :class="errorJM4" class="state-info top-right-pos-2">
                <p>JM4传感器</p>
                <p>
                  <span
                    >{{ humidityJM4 | toFixed }}% {{ temperatureJM4 | toFixed }}°C <br />
                    {{ pressureJM4 | toFixed }}Pa</span
                  >
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 ex8">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorCM6, humidityAllowedMaxCM6) }}
              </div>
              <div :class="errorCM6" class="state-info top-pos">
                <p>CM6传感器</p>
                <p>
                  <span
                    >{{ humidityCM6 | toFixed }}% {{ temperatureCM6 | toFixed }}°C <br />
                    {{ pressureCM6 | toFixed }}Pa</span
                  >
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor2 ex9">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorJM6, humidityAllowedMaxJM6) }}
              </div>
              <div :class="errorJM6" class="state-info top-left-pos-2">
                <p>JM6传感器*</p>
                <p>
                  <span
                    >{{ humidityJM6 | toFixed }}% {{ temperatureJM6 | toFixed }}°C <br />
                    {{ pressureJM6 | toFixed }}Pa</span
                  >
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 ex10">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorCM8, humidityAllowedMaxCM8) }}
              </div>
              <div :class="errorCM8" class="state-info right-pos">
                <p>CM8传感器</p>
                <p>
                  <span
                    >{{ humidityCM8 | toFixed }}% {{ temperatureCM8 | toFixed }}°C <br />
                    {{ pressureCM8 | toFixed }}Pa</span
                  >
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor2 ex11">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorJM8, humidityAllowedMaxJM8) }}
              </div>
              <div :class="errorJM8" class="state-info top-left-pos">
                <p>JM8传感器</p>
                <p>
                  <span
                    >{{ humidityJM8 | toFixed }}% {{ temperatureJM8 | toFixed }}°C <br />
                    {{ pressureJM8 | toFixed }}Pa</span
                  >
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 ex12">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorCM10, humidityAllowedMaxCM10) }}
              </div>
              <div :class="errorCM10" class="state-info right-pos">
                <p>CM10传感器</p>
                <p>
                  <span
                    >{{ humidityCM10 | toFixed }}% {{ temperatureCM10 | toFixed }}°C <br />
                    {{ pressureCM10 | toFixed }}Pa</span
                  >
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 ex13">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorCE4, humidityAllowedMaxCE4) }}
              </div>
              <div :class="errorCE4" class="state-info left-pos">
                <p>CE4传感器</p>
                <p>
                  <span
                    >{{ humidityCE4 | toFixed }}% {{ temperatureCE4 | toFixed }}°C <br />
                    {{ pressureCE4 | toFixed }}Pa</span
                  >
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor2 ex14">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorJE2, humidityAllowedMaxJE2) }}
              </div>
              <div :class="errorJE2" class="state-info top-left-pos">
                <p>JE2传感器</p>
                <p>
                  <span
                    >{{ humidityJE2 | toFixed }}% {{ temperatureJE2 | toFixed }}°C <br />
                    {{ pressureJE2 | toFixed }}Pa</span
                  >
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 ex15">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorCE2, humidityAllowedMaxCE2) }}
              </div>
              <div :class="errorCE2" class="state-info left-pos">
                <p>CE2传感器</p>
                <p>
                  <span
                    >{{ humidityCE2 | toFixed }}% {{ temperatureCE2 | toFixed }}°C <br />
                    {{ pressureCE2 | toFixed }}Pa</span
                  >
                </p>
              </div>
            </el-tooltip>
          </div>
        </div>
      </div>
    </div>

    <div class="main-cable" v-loading="loading">
      <div class="cable-title">
        <h2>上游气夹</h2>
      </div>
      <div class="cable-main">
        <div class="legend">
          <div class="sensor1">排气夹</div>
          <div class="sensor2">进气夹</div>
          <div class="sensor-source">数据来源: WINCC</div>
        </div>
        <!-- <div class="legend-station">
          <i class="iconfont iconshebei"></i>
          <span>除湿机</span>
        </div> -->
        <!-- <div class="legend-right">
          <div class="running">设备运行</div>
          <div class="stopped">设备停止</div>
          <div class="default">数据中断</div>
        </div> -->
        <div class="dir left-dir">
          <i class="iconfont icongeo-arrow-left"></i>
          <span class="dir-text">华坪</span>
        </div>
        <div class="dir right-dir">
          <i class="iconfont icongeo-arrow-left-copy"></i>
          <span class="dir-text">丽江</span>
        </div>
        <div class="cable-img">
          <el-tooltip class="station-block station-block-anchor-left" content="华坪上游锚室" effect="light" placement="top">
            <router-link class="iconfont iconshebei" to="/jinshajiang/stationAnchorPlc/huaping"></router-link>
          </el-tooltip>
          <div class="stati anchor-left">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{
                  assembleTooltip_dehumidifier(
                    "华坪上游锚室",
                    humidityTooltipErrorAnchorHuapingUp,
                    humidityAllowedMaxAnchorHuapingUp,
                    runningAnchorHuapingUp,
                    malfunctionAnchorHuapingUp
                  )
                }}
              </div>
              <div :class="errorAnchorHuapingUp" class="state-info right-pos" @dblclick="hrefToStation('')">
                <p>华坪上游锚室</p>
                <p>
                  <span>{{ humidityAnchorHuapingUp | toFixed }}% {{ temperatureAnchorHuapingUp | toFixed }}°C</span>
                  <span :class="runningClassAnchorHuapingUp" class="valve-sign"></span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <el-tooltip class="station-block station-block-anchor-right" content="丽江上游锚室" effect="light" placement="top">
            <router-link class="iconfont iconshebei" to="/jinshajiang/stationAnchorPlc/Lijiang"></router-link>
          </el-tooltip>
          <div class="stati anchor-right">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{
                  assembleTooltip_dehumidifier(
                    "丽江上游锚室",
                    humidityTooltipErrorAnchorLijiangUp,
                    humidityAllowedMaxAnchorLijiangUp,
                    runningAnchorLijiangUp,
                    malfunctionAnchorLijiangUp
                  )
                }}
              </div>
              <div :class="errorAnchorLijiangUp" class="state-info left-pos" @dblclick="hrefToStation('')">
                <p>丽江上游锚室</p>
                <p>
                  <span>{{ humidityAnchorLijiangUp | toFixed }}% {{ temperatureAnchorLijiangUp | toFixed }}°C</span>
                  <span :class="runningClassAnchorLijiangUp" class="valve-sign"></span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <el-tooltip class="station-block station-block-saddle-left" content="华坪上游鞍室" effect="light" placement="top">
            <router-link class="iconfont iconshebei" to="/jinshajiang/stationSaddlePlc/huaping"></router-link>
          </el-tooltip>
          <div class="stati saddle-left">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{
                  assembleTooltip_dehumidifier(
                    "华坪上游鞍室",
                    humidityTooltipErrorSaddleHuapingUp,
                    humidityAllowedMaxSaddleHuapingUp,
                    runningSaddleHuapingUp,
                    malfunctionSaddleHuapingUp
                  )
                }}
              </div>
              <div :class="errorSaddleHuapingUp" class="state-info bottom-right-pos" @dblclick="hrefToStation('')">
                <p>华坪上游鞍室</p>
                <p>
                  <span>{{ humiditySaddleHuapingUp | toFixed }}% {{ temperatureSaddleHuapingUp | toFixed }}°C</span>
                  <span :class="runningClassSaddleHuapingUp" class="valve-sign"></span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <el-tooltip class="station-block station-block-saddle-right" content="丽江上游鞍室" effect="light" placement="top">
            <router-link class="iconfont iconshebei" to="/jinshajiang/stationSaddlePlc/Lijiang"></router-link>
          </el-tooltip>
          <div class="stati saddle-right">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{
                  assembleTooltip_dehumidifier(
                    "丽江上游鞍室",
                    humidityTooltipErrorSaddleLijiangUp,
                    humidityAllowedMaxSaddleLijiangUp,
                    runningSaddleLijiangUp,
                    malfunctionSaddleLijiangUp
                  )
                }}
              </div>
              <div :class="errorSaddleLijiangUp" class="state-info bottom-left-pos" @dblclick="hrefToStation('')">
                <p>丽江上游鞍室</p>
                <p>
                  <span>{{ humiditySaddleLijiangUp | toFixed }}% {{ temperatureSaddleLijiangUp | toFixed }}°C</span>
                  <span :class="runningClassSaddleLijiangUp" class="valve-sign"></span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 ex1">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorCW1, humidityAllowedMaxCW1) }}
              </div>
              <div :class="errorCW1" class="state-info right-pos">
                <p>CW1传感器*</p>
                <p>
                  <span
                    >{{ humidityCW1 | toFixed }}% {{ temperatureCW1 | toFixed }}°C <br />
                    {{ pressureCW1 | toFixed }}Pa</span
                  >
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor2 ex2">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorJW1, humidityAllowedMaxJW1) }}
              </div>
              <div :class="errorJW1" class="state-info top-right-pos">
                <p>JW1传感器</p>
                <p>
                  <span
                    >{{ humidityJW1 | toFixed }}% {{ temperatureJW1 | toFixed }}°C <br />
                    {{ pressureJW1 | toFixed }}Pa</span
                  >
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 ex3">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorCW3, humidityAllowedMaxCW3) }}
              </div>
              <div :class="errorCW3" class="state-info right-pos">
                <p>CW3传感器</p>
                <p>
                  <span
                    >{{ humidityCW3 | toFixed }}% {{ temperatureCW3 | toFixed }}°C <br />
                    {{ pressureCW3 | toFixed }}Pa</span
                  >
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 ex4">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorCM1, humidityAllowedMaxCM1) }}
              </div>
              <div :class="errorCM1" class="state-info left-pos">
                <p>CM1传感器</p>
                <p>
                  <span
                    >{{ humidityCM1 | toFixed }}% {{ temperatureCM1 | toFixed }}°C <br />
                    {{ pressureCM1 | toFixed }}Pa</span
                  >
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor2 ex5">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorJM1, humidityAllowedMaxJM1) }}
              </div>
              <div :class="errorJM1" class="state-info top-right-pos">
                <p>JM1传感器</p>
                <p>
                  <span
                    >{{ humidityJM1 | toFixed }}% {{ temperatureJM1 | toFixed }}°C <br />
                    {{ pressureJM1 | toFixed }}Pa</span
                  >
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 ex6">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorCM3, humidityAllowedMaxCM3) }}
              </div>
              <div :class="errorCM3" class="state-info left-pos">
                <p>CM3传感器</p>
                <p>
                  <span
                    >{{ humidityCM3 | toFixed }}% {{ temperatureCM3 | toFixed }}°C <br />
                    {{ pressureCM3 | toFixed }}Pa</span
                  >
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor2 ex7">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorJM3, humidityAllowedMaxJM3) }}
              </div>
              <div :class="errorJM3" class="state-info top-right-pos-2">
                <p>JM3传感器</p>
                <p>
                  <span
                    >{{ humidityJM3 | toFixed }}% {{ temperatureJM3 | toFixed }}°C <br />
                    {{ pressureJM3 | toFixed }}Pa</span
                  >
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 ex8">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorCM5, humidityAllowedMaxCM5) }}
              </div>
              <div :class="errorCM5" class="state-info top-pos">
                <p>CM5传感器</p>
                <p>
                  <span
                    >{{ humidityCM5 | toFixed }}% {{ temperatureCM5 | toFixed }}°C <br />
                    {{ pressureCM5 | toFixed }}Pa</span
                  >
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor2 ex9">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorJM5, humidityAllowedMaxJM5) }}
              </div>
              <div :class="errorJM5" class="state-info top-left-pos-2">
                <p>JM5传感器</p>
                <p>
                  <span
                    >{{ humidityJM5 | toFixed }}% {{ temperatureJM5 | toFixed }}°C <br />
                    {{ pressureJM5 | toFixed }}Pa</span
                  >
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 ex10">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorCM7, humidityAllowedMaxCM7) }}
              </div>
              <div :class="errorCM7" class="state-info right-pos">
                <p>CM7传感器</p>
                <p>
                  <span
                    >{{ humidityCM7 | toFixed }}% {{ temperatureCM7 | toFixed }}°C <br />
                    {{ pressureCM7 | toFixed }}Pa</span
                  >
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor2 ex11">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorJM7, humidityAllowedMaxJM7) }}
              </div>
              <div :class="errorJM7" class="state-info top-left-pos">
                <p>JM7传感器</p>
                <p>
                  <span
                    >{{ humidityJM7 | toFixed }}% {{ temperatureJM7 | toFixed }}°C <br />
                    {{ pressureJM7 | toFixed }}Pa</span
                  >
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 ex12">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorCM9, humidityAllowedMaxCM9) }}
              </div>
              <div :class="errorCM9" class="state-info right-pos">
                <p>CM9传感器</p>
                <p>
                  <span
                    >{{ humidityCM9 | toFixed }}% {{ temperatureCM9 | toFixed }}°C <br />
                    {{ pressureCM9 | toFixed }}Pa</span
                  >
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 ex13">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorCE3, humidityAllowedMaxCE3) }}
              </div>
              <div :class="errorCE3" class="state-info left-pos">
                <p>CE3传感器</p>
                <p>
                  <span
                    >{{ humidityCE3 | toFixed }}% {{ temperatureCE3 | toFixed }}°C <br />
                    {{ pressureCE3 | toFixed }}Pa</span
                  >
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor2 ex14">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorJE1, humidityAllowedMaxJE1) }}
              </div>
              <div :class="errorJE1" class="state-info top-left-pos">
                <p>JE1传感器</p>
                <p>
                  <span
                    >{{ humidityJE1 | toFixed }}% {{ temperatureJE1 | toFixed }}°C <br />
                    {{ pressureJE1 | toFixed }}Pa</span
                  >
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 ex15">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorCE1, humidityAllowedMaxCE1) }}
              </div>
              <div :class="errorCE1" class="state-info left-pos">
                <p>CE1传感器</p>
                <p>
                  <span
                    >{{ humidityCE1 | toFixed }}% {{ temperatureCE1 | toFixed }}°C <br />
                    {{ pressureCE1 | toFixed }}Pa</span
                  >
                </p>
              </div>
            </el-tooltip>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "gasClamp",
  data() {
    return {
      loading: true,
      timer: null,

      //humidity, temperature
      humidityCW2: "--",
      humidityJW2: "--",
      humidityCW4: "--",
      humidityCM2: "--",
      humidityJM2: "--",
      humidityCM4: "--",
      humidityJM4: "--",
      humidityCM6: "--",
      humidityJM6: "--",
      humidityCM8: "--",
      humidityJM8: "--",
      humidityCM10: "--",
      humidityCE4: "--",
      humidityJE2: "--",
      humidityCE2: "--",
      humidityCW1: "--",
      humidityJW1: "--",
      humidityCW3: "--",
      humidityCM1: "--",
      humidityJM1: "--",
      humidityCM3: "--",
      humidityJM3: "--",
      humidityCM5: "--",
      humidityJM5: "--",
      humidityCM7: "--",
      humidityJM7: "--",
      humidityCM9: "--",
      humidityCE3: "--",
      humidityJE1: "--",
      humidityCE1: "--",

      humidityAnchorHuapingUp: "--",
      humidityAnchorHuapingDown: "--",
      humidityAnchorLijiangUp: "--",
      humidityAnchorLijiangDown: "--",
      humiditySaddleHuapingUp: "--",
      humiditySaddleHuapingDown: "--",
      humiditySaddleLijiangUp: "--",
      humiditySaddleLijiangDown: "--",

      temperatureCW2: "--",
      temperatureJW2: "--",
      temperatureCW4: "--",
      temperatureCM2: "--",
      temperatureJM2: "--",
      temperatureCM4: "--",
      temperatureJM4: "--",
      temperatureCM6: "--",
      temperatureJM6: "--",
      temperatureCM8: "--",
      temperatureJM8: "--",
      temperatureCM10: "--",
      temperatureCE4: "--",
      temperatureJE2: "--",
      temperatureCE2: "--",
      temperatureCW1: "--",
      temperatureJW1: "--",
      temperatureCW3: "--",
      temperatureCM1: "--",
      temperatureJM1: "--",
      temperatureCM3: "--",
      temperatureJM3: "--",
      temperatureCM5: "--",
      temperatureJM5: "--",
      temperatureCM7: "--",
      temperatureJM7: "--",
      temperatureCM9: "--",
      temperatureCE3: "--",
      temperatureJE1: "--",
      temperatureCE1: "--",

      temperatureAnchorHuapingUp: "--",
      temperatureAnchorHuapingDown: "--",
      temperatureAnchorLijiangUp: "--",
      temperatureAnchorLijiangDown: "--",
      temperatureSaddleHuapingUp: "--",
      temperatureSaddleHuapingDown: "--",
      temperatureSaddleLijiangUp: "--",
      temperatureSaddleLijiangDown: "--",

      pressureCW2: "--",
      pressureJW2: "--",
      pressureCW4: "--",
      pressureCM2: "--",
      pressureJM2: "--",
      pressureCM4: "--",
      pressureJM4: "--",
      pressureCM6: "--",
      pressureJM6: "--",
      pressureCM8: "--",
      pressureJM8: "--",
      pressureCM10: "--",
      pressureCE4: "--",
      pressureJE2: "--",
      pressureCE2: "--",
      pressureCW1: "--",
      pressureJW1: "--",
      pressureCW3: "--",
      pressureCM1: "--",
      pressureJM1: "--",
      pressureCM3: "--",
      pressureJM3: "--",
      pressureCM5: "--",
      pressureJM5: "--",
      pressureCM7: "--",
      pressureJM7: "--",
      pressureCM9: "--",
      pressureCE3: "--",
      pressureJE1: "--",
      pressureCE1: "--",

      //running
      runningAnchorHuapingUp: "--",
      runningAnchorHuapingDown: "--",
      runningAnchorLijiangUp: "--",
      runningAnchorLijiangDown: "--",
      runningSaddleHuapingUp: "--",
      runningSaddleHuapingDown: "--",
      runningSaddleLijiangUp: "--",
      runningSaddleLijiangDown: "--",

      //malfunction
      malfunctionAnchorHuapingUp: "--",
      malfunctionAnchorHuapingDown: "--",
      malfunctionAnchorLijiangUp: "--",
      malfunctionAnchorLijiangDown: "--",
      malfunctionSaddleHuapingUp: "--",
      malfunctionSaddleHuapingDown: "--",
      malfunctionSaddleLijiangUp: "--",
      malfunctionSaddleLijiangDown: "--",

      //error
      errorCW2: "--",
      errorJW2: "--",
      errorCW4: "--",
      errorCM2: "--",
      errorJM2: "--",
      errorCM4: "--",
      errorJM4: "--",
      errorCM6: "--",
      errorJM6: "--",
      errorCM8: "--",
      errorJM8: "--",
      errorCM10: "--",
      errorCE4: "--",
      errorJE2: "--",
      errorCE2: "--",
      errorCW1: "--",
      errorJW1: "--",
      errorCW3: "--",
      errorCM1: "--",
      errorJM1: "--",
      errorCM3: "--",
      errorJM3: "--",
      errorCM5: "--",
      errorJM5: "--",
      errorCM7: "--",
      errorJM7: "--",
      errorCM9: "--",
      errorCE3: "--",
      errorJE1: "--",
      errorCE1: "--",

      errorSaddleLijiangUp: "--",
      errorSaddleLijiangDown: "--",
      errorSaddleHuapingUp: "--",
      errorSaddleHuapingDown: "--",
      errorAnchorLijiangUp: "--",
      errorAnchorLijiangDown: "--",
      errorAnchorHuapingUp: "--",
      errorAnchorHuapingDown: "--",

      //running class
      runningClassAnchorHuapingUp: "--",
      runningClassAnchorHuapingDown: "--",
      runningClassAnchorLijiangUp: "--",
      runningClassAnchorLijiangDown: "--",
      runningClassSaddleHuapingUp: "--",
      runningClassSaddleHuapingDown: "--",
      runningClassSaddleLijiangUp: "--",
      runningClassSaddleLijiangDown: "--",

      //humidity allowed max
      humidityAllowedMaxCW2: "--",
      humidityAllowedMaxJW2: "--",
      humidityAllowedMaxCW4: "--",
      humidityAllowedMaxCM2: "--",
      humidityAllowedMaxJM2: "--",
      humidityAllowedMaxCM4: "--",
      humidityAllowedMaxJM4: "--",
      humidityAllowedMaxCM6: "--",
      humidityAllowedMaxJM6: "--",
      humidityAllowedMaxCM8: "--",
      humidityAllowedMaxJM8: "--",
      humidityAllowedMaxCM10: "--",
      humidityAllowedMaxCE4: "--",
      humidityAllowedMaxJE2: "--",
      humidityAllowedMaxCE2: "--",
      humidityAllowedMaxCW1: "--",
      humidityAllowedMaxJW1: "--",
      humidityAllowedMaxCW3: "--",
      humidityAllowedMaxCM1: "--",
      humidityAllowedMaxJM1: "--",
      humidityAllowedMaxCM3: "--",
      humidityAllowedMaxJM3: "--",
      humidityAllowedMaxCM5: "--",
      humidityAllowedMaxJM5: "--",
      humidityAllowedMaxCM7: "--",
      humidityAllowedMaxJM7: "--",
      humidityAllowedMaxCM9: "--",
      humidityAllowedMaxCE3: "--",
      humidityAllowedMaxJE1: "--",
      humidityAllowedMaxCE1: "--",

      humidityAllowedMaxAnchorHuapingUp: "--",
      humidityAllowedMaxAnchorHuapingDown: "--",
      humidityAllowedMaxAnchorLijiangUp: "--",
      humidityAllowedMaxAnchorLijiangDown: "--",
      humidityAllowedMaxSaddleHuapingUp: "--",
      humidityAllowedMaxSaddleHuapingDown: "--",
      humidityAllowedMaxSaddleLijiangUp: "--",
      humidityAllowedMaxSaddleLijiangDown: "--",

      //humidity tooltip error
      humidityTooltipErrorCW2: "--",
      humidityTooltipErrorJW2: "--",
      humidityTooltipErrorCW4: "--",
      humidityTooltipErrorCM2: "--",
      humidityTooltipErrorJM2: "--",
      humidityTooltipErrorCM4: "--",
      humidityTooltipErrorJM4: "--",
      humidityTooltipErrorCM6: "--",
      humidityTooltipErrorJM6: "--",
      humidityTooltipErrorCM8: "--",
      humidityTooltipErrorJM8: "--",
      humidityTooltipErrorCM10: "--",
      humidityTooltipErrorCE4: "--",
      humidityTooltipErrorJE2: "--",
      humidityTooltipErrorCE2: "--",
      humidityTooltipErrorCW1: "--",
      humidityTooltipErrorJW1: "--",
      humidityTooltipErrorCW3: "--",
      humidityTooltipErrorCM1: "--",
      humidityTooltipErrorJM1: "--",
      humidityTooltipErrorCM3: "--",
      humidityTooltipErrorJM3: "--",
      humidityTooltipErrorCM5: "--",
      humidityTooltipErrorJM5: "--",
      humidityTooltipErrorCM7: "--",
      humidityTooltipErrorJM7: "--",
      humidityTooltipErrorCM9: "--",
      humidityTooltipErrorCE3: "--",
      humidityTooltipErrorJE1: "--",
      humidityTooltipErrorCE1: "--",

      humidityTooltipErrorAnchorHuapingUp: "--",
      humidityTooltipErrorAnchorHuapingDown: "--",
      humidityTooltipErrorAnchorLijiangUp: "--",
      humidityTooltipErrorAnchorLijiangDown: "--",
      humidityTooltipErrorSaddleHuapingUp: "--",
      humidityTooltipErrorSaddleHuapingDown: "--",
      humidityTooltipErrorSaddleLijiangUp: "--",
      humidityTooltipErrorSaddleLijiangDown: "--",

      dataNameIdDict: {
        //humidity, temperature
        humidityCW2: "64e7910d-befc-4ffd-9250-20d28ca6d078",
        humidityJW2: "fe7cbbbd-524b-4a66-8908-aeae993929be",
        humidityCW4: "0ef83c5e-1434-495a-aca6-68608e1fe155",
        humidityCM2: "2e7cc90d-43a5-49c5-9822-468793d394f3",
        humidityJM2: "e7a76fe8-9c80-4aa8-b762-019084452be9",
        humidityCM4: "4d010112-fb53-4ad8-8163-3dfb3ffb7d37",
        humidityJM4: "e3e055cb-7cba-429a-8dcb-dd136f5a8c93",
        humidityCM6: "6a2d8f01-b7f8-49f9-aaea-fe16a9d33f20",
        humidityJM6: "127aa07e-af03-471e-9e61-6e10e3c67f76",
        humidityCM8: "12a18e1d-9e4e-4861-bb70-c6d3716f8a5e",
        humidityJM8: "b1144cfe-9dc2-4fda-9e2d-44cdde9a7930",
        humidityCM10: "e29c1371-60df-4619-98e5-2e0f7e24379e",
        humidityCE4: "b9beaec9-d4fa-4866-a8bc-c94056099adf",
        humidityJE2: "8e978520-0b50-4e12-9fce-504ba3ce2936",
        humidityCE2: "aac73783-14c2-4c6b-bea9-2291c60619a9",
        humidityCW1: "023c7930-4fdc-4c8c-b04b-16cc62e3e899",
        humidityJW1: "175a8808-663b-465c-a45d-ac9040a83c6c",
        humidityCW3: "17e2f31c-3e86-4118-904b-15f8a1592d3d",
        humidityCM1: "79cadd01-fa71-471b-880a-d1abc1594687",
        humidityJM1: "19bf6aaa-d59e-4621-a9d5-64c28171ead1",
        humidityCM3: "4e3376a3-d575-4187-b2cf-d7bf0b9c83bd",
        humidityJM3: "76697d7e-07ad-4a11-9fc1-9e338188acff",
        humidityCM5: "b8be41df-0112-441b-84c9-976722130b5d",
        humidityJM5: "8d04e509-24e5-4c10-91da-a92bf4889311",
        humidityCM7: "f48b39bd-cfd8-4606-92dd-86cd1bfbb530",
        humidityJM7: "c6e3ee67-14ed-4a19-b869-23a50833d8c0",
        humidityCM9: "398a841f-aed5-4375-9375-97d575bf7824",
        humidityCE3: "ef6a9e20-40e3-4dd2-a78b-3612a5c3b574",
        humidityJE1: "6ead0e95-4ff5-4d8b-9b41-ef54453dcbd3",
        humidityCE1: "90ae78c7-542d-45cc-81d4-fd24083a71f5",

        humidityAnchorHuapingUp: "5c2dab2d-f45e-45ea-9da4-8b398b114b28",
        humidityAnchorHuapingDown: "d4e84dcb-b8f3-442b-8984-0946a0d0e9f5",
        humidityAnchorLijiangUp: "719d1f76-5a17-4b34-ad9f-affbc312ee98",
        humidityAnchorLijiangDown: "b5269f1c-e44e-4e2c-a035-5c69b4523fe8",
        humiditySaddleHuapingUp: "4002431e-8b97-459a-9e4b-5454e143023b",
        humiditySaddleHuapingDown: "f4eed4a2-c3b2-41e0-87d0-f83c0c078f73",
        humiditySaddleLijiangUp: "79e95616-000b-4c13-8b80-52eb48f5228b",
        humiditySaddleLijiangDown: "8b315c32-2871-4c97-b6bf-e2430b9166f4",

        temperatureCW2: "fcf5d4ee-7678-4ec8-8fa9-3643adb49f65",
        temperatureJW2: "68cee81c-11c5-435a-8f72-407c876576ad",
        temperatureCW4: "4a84aad1-dbb5-462b-91a6-20aaad5eba83",
        temperatureCM2: "8f1dbc52-e14f-4e1c-82b7-ad2b9a91941e",
        temperatureJM2: "f8aa2106-9cf4-40bd-9336-c05a29388df6",
        temperatureCM4: "906ff7e7-1df4-4025-8b7f-01617133cd71",
        temperatureJM4: "d442a8b5-260d-479e-956c-79f0f1313430",
        temperatureCM6: "8b78a804-71fd-40a0-92ef-344e28b3d0ed",
        temperatureJM6: "81b7a61f-eb96-479a-967f-ade1f7883cdc",
        temperatureCM8: "9ab1d10c-feb4-4158-9677-cddfd64cf32a",
        temperatureJM8: "62b4772f-5287-4115-9bc3-04de264dc936",
        temperatureCM10: "1f611c19-6084-4260-98ca-c880261b0e12",
        temperatureCE4: "a655bd0f-b8da-46f3-bcae-1e41cb577769",
        temperatureJE2: "631df59e-4d29-4e80-bb90-969e20aa2e3a",
        temperatureCE2: "32044469-8add-4659-b443-93a30c6e860c",
        temperatureCW1: "535ce2d8-e9f2-4b26-8472-bc4ff890f465",
        temperatureJW1: "c5d5b898-8b33-4321-899f-62ae3dcd65fc",
        temperatureCW3: "133d8653-2097-49a6-964b-c7c00cbd784a",
        temperatureCM1: "f4315907-0104-4cbc-b95f-2dde57404f8c",
        temperatureJM1: "2c30baf9-a5a7-477a-9740-bf13a1a8048d",
        temperatureCM3: "85d9b723-8997-4f25-9261-3ecd29f0be9c",
        temperatureJM3: "6e74379a-2120-4983-9712-a6fa66645af7",
        temperatureCM5: "73e040f2-19f3-45a9-90b1-5476a1cc156d",
        temperatureJM5: "629eb945-7d70-415b-af21-36b7b9bd1df0",
        temperatureCM7: "f06d2c67-6982-4a5a-a54c-baba9a23ae21",
        temperatureJM7: "e723edf9-31a1-4397-9c5a-6eb7c2d650ff",
        temperatureCM9: "69740019-e608-451d-a9bf-4644a33cb066",
        temperatureCE3: "66354edc-51b4-4477-b248-9cb275bfbf0b",
        temperatureJE1: "afd6b71b-1765-4136-9087-3d4a62fd0e3e",
        temperatureCE1: "833234be-41db-4563-9358-d03363468529",

        temperatureAnchorHuapingUp: "c122b9fc-728d-4637-a05e-aec74ab83c33",
        temperatureAnchorHuapingDown: "b0d741f7-ac2b-413d-b14a-59a379da5a0a",
        temperatureAnchorLijiangUp: "3ea05222-c56e-4853-abd6-46a4c3e7c2ab",
        temperatureAnchorLijiangDown: "905b6ad8-2635-431b-9cdd-022d8847e08d",
        temperatureSaddleHuapingUp: "e89264d0-f690-4357-ac52-83f2c2e09d33",
        temperatureSaddleHuapingDown: "726dd1f0-a938-4ef8-a36d-a30b60a188b4",
        temperatureSaddleLijiangUp: "7e6e762a-8b6f-4df0-8ecb-cf93c3178154",
        temperatureSaddleLijiangDown: "92225508-7745-4266-bc1a-6a1871c3492f",

        pressureCW1: "ebd3bfc7-9f9f-4134-8a72-cc46302416b9",
        pressureJW1: "5d2f0f24-5362-4cb5-baec-c41226089177",
        pressureCW3: "3cd124f1-1fa1-4a99-bf16-120da2859dc3",
        pressureCM1: "9d429e13-060b-4343-b036-f579a856f20c",
        pressureJM1: "fb1838e7-aec8-4600-a77e-77221f79ab5a",
        pressureCM3: "594079ae-f507-45b7-9bcf-8f4e33cdbf0b",
        pressureJM3: "29c93b41-8d45-4ade-843e-aac753acf58b",
        pressureCM5: "1f36daa3-de92-434a-ad0a-e2494239a29b",
        pressureCW2: "f2e18dd3-a4b7-4117-b858-f68b9eb997f9",
        pressureJW2: "bc9cdfdd-17b4-489f-9a11-63f0e2a21809",
        pressureCW4: "17b80375-5028-40f0-9102-f5f36b463d43",
        pressureCM2: "f6470632-012c-48d1-a956-e89e6731e0ec",
        pressureJM2: "9ac9d980-cfe0-42d1-bbd5-2a15e206795b",
        pressureCM4: "943b9b2b-9928-4aca-a57b-2cb20aec84c5",
        pressureJM4: "0e850e01-bbe5-4859-892f-c944e6339685",
        pressureCM6: "2730ac34-1574-4baa-8f21-efa992d69310",
        pressureCE1: "d986b4f3-51c2-4db0-a016-1b23b13a5571",
        pressureJE1: "115a2116-1dff-45e9-a2f5-5ee43091f2ce",
        pressureCE3: "89e6d9f1-09d5-4266-8632-3ecb7ec57ba0",
        pressureCM9: "96022f67-db06-4d9e-afcb-9ea38616c0c6",
        pressureJM7: "6fb603a5-3de4-4a88-893e-0cf7f19e78fd",
        pressureCM7: "e07aa949-09a1-4677-bac0-119829cf67aa",
        pressureJM5: "312e0027-b223-42e2-aee5-dc6740c09473",
        pressureCE2: "3d8082cb-4dd7-40c0-a52f-a4f0aa5de0ee",
        pressureJE2: "ee0cfd12-d530-485c-be94-7f10dba9880f",
        pressureCE4: "bb1a188f-8423-4b23-bbca-d69f36b2beb3",
        pressureCM10: "0bd96037-446d-41d3-8d55-a0a4db202d54",
        pressureJM8: "32d00c00-60b7-4815-a712-405d88537a82",
        pressureCM8: "94a0d346-78f5-4a32-a1f8-93c06e44f74c",
        pressureJM6: "5aad7371-6265-49b8-869c-42dc9aa2d678",

        //running
        runningAnchorHuapingUp: "72a78f89-7b67-4b99-add5-bc9a41479f8b",
        runningAnchorHuapingDown: "6dff3e48-a93f-448b-8ca1-727786cd9dfa",
        runningAnchorLijiangUp: "b7ecb9c2-0fe2-4aca-b9e6-28d9f2194ddf",
        runningAnchorLijiangDown: "0a6bb24b-6367-4272-b0d4-50c75b6344d6",
        runningSaddleHuapingUp: "56227bbd-095b-4be9-b156-245bbf8535f3",
        runningSaddleHuapingDown: "a1c0da5a-4229-450f-b7cc-20f1d9d63e99",
        runningSaddleLijiangUp: "df087d58-7133-4fb3-a864-73a491afcaaa",
        runningSaddleLijiangDown: "7e4b7ae5-7af5-4dc4-bc45-db687fe8bdd7",

        //malfunction
        malfunctionAnchorHuapingUp: "de03c625-98c6-4022-bfed-a3ebf993e188",
        malfunctionAnchorHuapingDown: "ac9baa1d-55f5-484e-afc6-55128767b665",
        malfunctionAnchorLijiangUp: "1945ac01-4771-4796-b397-24e5544fa161",
        malfunctionAnchorLijiangDown: "374f45bb-7ae4-4309-8214-a8fd93f23cc6",
        malfunctionSaddleHuapingUp: "b205f5df-4f86-4374-972d-00f4495c6719",
        malfunctionSaddleHuapingDown: "2eb29923-8129-4a82-b94c-3ff1b0e081cb",
        malfunctionSaddleLijiangUp: "c2833409-c1c5-467a-bf88-95b32e57722b",
        malfunctionSaddleLijiangDown: "79e2c532-a478-439f-9afc-fd46532f32b7",
      },

      //humidity allowed max -> id
      allowedMaxNameIdDict: {
        humidityAllowedMaxCW2: "64e7910d-befc-4ffd-9250-20d28ca6d078",
        humidityAllowedMaxJW2: "fe7cbbbd-524b-4a66-8908-aeae993929be",
        humidityAllowedMaxCW4: "0ef83c5e-1434-495a-aca6-68608e1fe155",
        humidityAllowedMaxCM2: "2e7cc90d-43a5-49c5-9822-468793d394f3",
        humidityAllowedMaxJM2: "e7a76fe8-9c80-4aa8-b762-019084452be9",
        humidityAllowedMaxCM4: "4d010112-fb53-4ad8-8163-3dfb3ffb7d37",
        humidityAllowedMaxJM4: "e3e055cb-7cba-429a-8dcb-dd136f5a8c93",
        humidityAllowedMaxCM6: "6a2d8f01-b7f8-49f9-aaea-fe16a9d33f20",
        humidityAllowedMaxJM6: "127aa07e-af03-471e-9e61-6e10e3c67f76",
        humidityAllowedMaxCM8: "12a18e1d-9e4e-4861-bb70-c6d3716f8a5e",
        humidityAllowedMaxJM8: "b1144cfe-9dc2-4fda-9e2d-44cdde9a7930",
        humidityAllowedMaxCM10: "e29c1371-60df-4619-98e5-2e0f7e24379e",
        humidityAllowedMaxCE4: "b9beaec9-d4fa-4866-a8bc-c94056099adf",
        humidityAllowedMaxJE2: "8e978520-0b50-4e12-9fce-504ba3ce2936",
        humidityAllowedMaxCE2: "aac73783-14c2-4c6b-bea9-2291c60619a9",
        humidityAllowedMaxCW1: "023c7930-4fdc-4c8c-b04b-16cc62e3e899",
        humidityAllowedMaxJW1: "175a8808-663b-465c-a45d-ac9040a83c6c",
        humidityAllowedMaxCW3: "17e2f31c-3e86-4118-904b-15f8a1592d3d",
        humidityAllowedMaxCM1: "79cadd01-fa71-471b-880a-d1abc1594687",
        humidityAllowedMaxJM1: "19bf6aaa-d59e-4621-a9d5-64c28171ead1",
        humidityAllowedMaxCM3: "4e3376a3-d575-4187-b2cf-d7bf0b9c83bd",
        humidityAllowedMaxJM3: "76697d7e-07ad-4a11-9fc1-9e338188acff",
        humidityAllowedMaxCM5: "b8be41df-0112-441b-84c9-976722130b5d",
        humidityAllowedMaxJM5: "8d04e509-24e5-4c10-91da-a92bf4889311",
        humidityAllowedMaxCM7: "f48b39bd-cfd8-4606-92dd-86cd1bfbb530",
        humidityAllowedMaxJM7: "c6e3ee67-14ed-4a19-b869-23a50833d8c0",
        humidityAllowedMaxCM9: "398a841f-aed5-4375-9375-97d575bf7824",
        humidityAllowedMaxCE3: "ef6a9e20-40e3-4dd2-a78b-3612a5c3b574",
        humidityAllowedMaxJE1: "6ead0e95-4ff5-4d8b-9b41-ef54453dcbd3",
        humidityAllowedMaxCE1: "90ae78c7-542d-45cc-81d4-fd24083a71f5",

        humidityAllowedMaxAnchorHuapingUp: "5c2dab2d-f45e-45ea-9da4-8b398b114b28",
        humidityAllowedMaxAnchorHuapingDown: "d4e84dcb-b8f3-442b-8984-0946a0d0e9f5",
        humidityAllowedMaxAnchorLijiangUp: "719d1f76-5a17-4b34-ad9f-affbc312ee98",
        humidityAllowedMaxAnchorLijiangDown: "b5269f1c-e44e-4e2c-a035-5c69b4523fe8",
        humidityAllowedMaxSaddleHuapingUp: "4002431e-8b97-459a-9e4b-5454e143023b",
        humidityAllowedMaxSaddleHuapingDown: "f4eed4a2-c3b2-41e0-87d0-f83c0c078f73",
        humidityAllowedMaxSaddleLijiangUp: "79e95616-000b-4c13-8b80-52eb48f5228b",
        humidityAllowedMaxSaddleLijiangDown: "8b315c32-2871-4c97-b6bf-e2430b9166f4",
      },

      //humidity, temperature -> error
      dataNameErrorNameDict: {
        humidityCW2: "errorCW2",
        humidityJW2: "errorJW2",
        humidityCW4: "errorCW4",
        humidityCM2: "errorCM2",
        humidityJM2: "errorJM2",
        humidityCM4: "errorCM4",
        humidityJM4: "errorJM4",
        humidityCM6: "errorCM6",
        humidityJM6: "errorJM6",
        humidityCM8: "errorCM8",
        humidityJM8: "errorJM8",
        humidityCM10: "errorCM10",
        humidityCE4: "errorCE4",
        humidityJE2: "errorJE2",
        humidityCE2: "errorCE2",
        humidityCW1: "errorCW1",
        humidityJW1: "errorJW1",
        humidityCW3: "errorCW3",
        humidityCM1: "errorCM1",
        humidityJM1: "errorJM1",
        humidityCM3: "errorCM3",
        humidityJM3: "errorJM3",
        humidityCM5: "errorCM5",
        humidityJM5: "errorJM5",
        humidityCM7: "errorCM7",
        humidityJM7: "errorJM7",
        humidityCM9: "errorCM9",
        humidityCE3: "errorCE3",
        humidityJE1: "errorJE1",
        humidityCE1: "errorCE1",

        humidityAnchorHuapingUp: "errorAnchorHuapingUp",
        humidityAnchorHuapingDown: "errorAnchorHuapingDown",
        humidityAnchorLijiangUp: "errorAnchorLijiangUp",
        humidityAnchorLijiangDown: "errorAnchorLijiangDown",
        humiditySaddleHuapingUp: "errorSaddleHuapingUp",
        humiditySaddleHuapingDown: "errorSaddleHuapingDown",
        humiditySaddleLijiangUp: "errorSaddleLijiangUp",
        humiditySaddleLijiangDown: "errorSaddleLijiangDown",

        temperaturerCW2: "errorCW2",
        temperaturerJW2: "errorJW2",
        temperaturerCW4: "errorCW4",
        temperaturerCM2: "errorCM2",
        temperaturerJM2: "errorJM2",
        temperaturerCM4: "errorCM4",
        temperaturerJM4: "errorJM4",
        temperaturerCM6: "errorCM6",
        temperaturerJM6: "errorJM6",
        temperaturerCM8: "errorCM8",
        temperaturerJM8: "errorJM8",
        temperaturerCM10: "errorCM10",
        temperaturerCE4: "errorCE4",
        temperaturerJE2: "errorJE2",
        temperaturerCE2: "errorCE2",
        temperaturerCW1: "errorCW1",
        temperaturerJW1: "errorJW1",
        temperaturerCW3: "errorCW3",
        temperaturerCM1: "errorCM1",
        temperaturerJM1: "errorJM1",
        temperaturerCM3: "errorCM3",
        temperaturerJM3: "errorJM3",
        temperaturerCM5: "errorCM5",
        temperaturerJM5: "errorJM5",
        temperaturerCM7: "errorCM7",
        temperaturerJM7: "errorJM7",
        temperaturerCM9: "errorCM9",
        temperaturerCE3: "errorCE3",
        temperaturerJE1: "errorJE1",
        temperaturerCE1: "errorCE1",

        temperatureAnchorHuapingUp: "errorAnchorHuapingUp",
        temperatureAnchorHuapingDown: "errorAnchorHuapingDown",
        temperatureAnchorLijiangUp: "errorAnchorLijiangUp",
        temperatureAnchorLijiangDown: "errorAnchorLijiangDown",
        temperatureSaddleHuapingUp: "errorSaddleHuapingUp",
        temperatureSaddleHuapingDown: "errorSaddleHuapingDown",
        temperatureSaddleLijiangUp: "errorSaddleLijiangUp",
        temperatureSaddleLijiangDown: "errorSaddleLijiangDown",

        pressureCW2: "errorCW2",
        pressureJW2: "errorJW2",
        pressureCW4: "errorCW4",
        pressureCM2: "errorCM2",
        pressureJM2: "errorJM2",
        pressureCM4: "errorCM4",
        pressureJM4: "errorJM4",
        pressureCM6: "errorCM6",
        pressureJM6: "errorJM6",
        pressureCM8: "errorCM8",
        pressureJM8: "errorJM8",
        pressureCM10: "errorCM10",
        pressureCE4: "errorCE4",
        pressureJE2: "errorJE2",
        pressureCE2: "errorCE2",
        pressureCW1: "errorCW1",
        pressureJW1: "errorJW1",
        pressureCW3: "errorCW3",
        pressureCM1: "errorCM1",
        pressureJM1: "errorJM1",
        pressureCM3: "errorCM3",
        pressureJM3: "errorJM3",
        pressureCM5: "errorCM5",
        pressureJM5: "errorJM5",
        pressureCM7: "errorCM7",
        pressureJM7: "errorJM7",
        pressureCM9: "errorCM9",
        pressureCE3: "errorCE3",
        pressureJE1: "errorJE1",
        pressureCE1: "errorCE1",
      },

      //malfunction -> error
      malfunctionDataNameErrorNameDict: {
        malfunctionAnchorHuapingUp: "errorAnchorHuapingUp",
        malfunctionAnchorHuapingDown: "errorAnchorHuapingDown",
        malfunctionAnchorLijiangUp: "errorAnchorLijiangUp",
        malfunctionAnchorLijiangDown: "errorAnchorLijiangDown",
        malfunctionSaddleHuapingUp: "errorSaddleHuapingUp",
        malfunctionSaddleHuapingDown: "errorSaddleHuapingDown",
        malfunctionSaddleLijiangUp: "errorSaddleLijiangUp",
        malfunctionSaddleLijiangDown: "errorSaddleLijiangDown",
      },

      //humidity -> humidity tooltip error
      dataNameTooltipErrorNameDict: {
        humidityCW2: "humidityTooltipErrorCW2",
        humidityJW2: "humidityTooltipErrorJW2",
        humidityCW4: "humidityTooltipErrorCW4",
        humidityCM2: "humidityTooltipErrorCM2",
        humidityJM2: "humidityTooltipErrorJM2",
        humidityCM4: "humidityTooltipErrorCM4",
        humidityJM4: "humidityTooltipErrorJM4",
        humidityCM6: "humidityTooltipErrorCM6",
        humidityJM6: "humidityTooltipErrorJM6",
        humidityCM8: "humidityTooltipErrorCM8",
        humidityJM8: "humidityTooltipErrorJM8",
        humidityCM10: "humidityTooltipErrorCM10",
        humidityCE4: "humidityTooltipErrorCE4",
        humidityJE2: "humidityTooltipErrorJE2",
        humidityCE2: "humidityTooltipErrorCE2",
        humidityCW1: "humidityTooltipErrorCW1",
        humidityJW1: "humidityTooltipErrorJW1",
        humidityCW3: "humidityTooltipErrorCW3",
        humidityCM1: "humidityTooltipErrorCM1",
        humidityJM1: "humidityTooltipErrorJM1",
        humidityCM3: "humidityTooltipErrorCM3",
        humidityJM3: "humidityTooltipErrorJM3",
        humidityCM5: "humidityTooltipErrorCM5",
        humidityJM5: "humidityTooltipErrorJM5",
        humidityCM7: "humidityTooltipErrorCM7",
        humidityJM7: "humidityTooltipErrorJM7",
        humidityCM9: "humidityTooltipErrorCM9",
        humidityCE3: "humidityTooltipErrorCE3",
        humidityJE1: "humidityTooltipErrorJE1",
        humidityCE1: "humidityTooltipErrorCE1",

        humidityAnchorHuapingUp: "humidityTooltipErrorAnchorHuapingUp",
        humidityAnchorHuapingDown: "humidityTooltipErrorAnchorHuapingDown",
        humidityAnchorLijiangUp: "humidityTooltipErrorAnchorLijiangUp",
        humidityAnchorLijiangDown: "humidityTooltipErrorAnchorLijiangDown",
        humiditySaddleHuapingUp: "humidityTooltipErrorSaddleHuapingUp",
        humiditySaddleHuapingDown: "humidityTooltipErrorSaddleHuapingDown",
        humiditySaddleLijiangUp: "humidityTooltipErrorSaddleLijiangUp",
        humiditySaddleLijiangDown: "humidityTooltipErrorSaddleLijiangDown",
      },

      //running -> running class
      dataNameRunningClassNameDict: {
        runningAnchorHuapingUp: "runningClassAnchorHuapingUp",
        runningAnchorHuapingDown: "runningClassAnchorHuapingDown",
        runningAnchorLijiangUp: "runningClassAnchorLijiangUp",
        runningAnchorLijiangDown: "runningClassAnchorLijiangDown",
        runningSaddleHuapingUp: "runningClassSaddleHuapingUp",
        runningSaddleHuapingDown: "runningClassSaddleHuapingDown",
        runningSaddleLijiangUp: "runningClassSaddleLijiangUp",
        runningSaddleLijiangDown: "runningClassSaddleLijiangDown",
      },

      //station id list
      stationIdList: [
        "408f5bda-f87d-4bfe-bb6f-7c5a92a48081",
        "35d83882-3b43-4c8c-a2cc-f70aded67a4a",
        "6015a418-b7b1-497f-b1de-a9aa65e47891",
        "994ba00b-ce96-45fb-949b-2b505cc870d3",
        "ec951680-cab7-45c9-8406-35eee2cfb716",
        "6aea0e2d-41bd-4dd3-b481-14cd7ca2f589",
        "ada15150-d814-4526-baa2-f2a8ff5d38c7",
        "7b409dd1-4e96-4061-b8cf-8a7d87f1f5f0",
        "8ff543c4-b47f-4b38-a67b-7ac2f4e84d19",
        "93148943-41ba-411b-b091-aafd59f4ba59",
      ],
    };
  },
  filters: {
    toFixed(val) {
      if (val === 0) return "0.0";
      if (!Number(val)) return "--";
      return Number(val).toFixed(1);
    },
  },
  mounted() {
    this.getAllowedMax();
    this.getData();
    this.timer = setInterval(() => {
      this.getData();
    }, this.REFRESH_SECOND);
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
  methods: {
    refreshData() {
      this.loading = true;
      this.getData();
    },
    getData() {
      this.resetError();
      let stationRequestList = [];
      this.stationIdList.forEach((stationId) => {
        stationRequestList.push(this.$http.get(`/deviceData/Station?stationId=${stationId}`));
      });

      this.$http.all(stationRequestList).then(
        this.$http.spread((...resList) => {
          resList.forEach((res) => {
            this.setDataAndError(res.data);
            this.loading = false;
          });
        })
      );
    },
    setDataAndError(stationData) {
      //device id not set (device id = 'GUID') = no data
      stationData["GUID"] = {
        dataId: null,
        deviceId: "GUID",
        value: null,
        createdDate: "0001-01-01T00:00:00",
        dataDate: "0001-01-01T00:00:00",
        dataType: "VALUE",
        errorLevel: "Warning",
      };

      for (let dataName in this.dataNameIdDict) {
        const dataId = this.dataNameIdDict[dataName];
        if (stationData[dataId] !== undefined) {
          this[dataName] = stationData[dataId].value;

          // //set value for running sign
          // if (this.dataNameRunningTooltipNameDict[dataName] !== undefined && this.dataNameRunningClassNameDict[dataName] != undefined) {
          //   let runningData = stationData[dataId];
          //   if (runningData.value === 1) {
          //     this[this.dataNameRunningTooltipNameDict[dataName]] = "运行";
          //     this[this.dataNameRunningClassNameDict[dataName]] = "running";
          //   } else if (runningData.errorLevel !== "Warning") {
          //     //empty data value also === 0
          //     this[this.dataNameRunningTooltipNameDict[dataName]] = "停止";
          //     this[this.dataNameRunningClassNameDict[dataName]] = "stopped";
          //   }
          // }

          //set value for running sign
          if (this.dataNameRunningClassNameDict[dataName] != undefined) {
            let runningData = stationData[dataId];
            if (runningData.value === 1) {
              this[this.dataNameRunningClassNameDict[dataName]] = "running";
            } else if (runningData.errorLevel !== "Warning") {
              //empty data value also === 0
              this[this.dataNameRunningClassNameDict[dataName]] = "stopped";
            }
          }

          if (this.dataNameErrorNameDict[dataName] !== undefined) {
            const errorName = this.dataNameErrorNameDict[dataName];
            this[errorName] = this.getErrorLevelFromMultipleDevice(this[errorName], stationData[dataId].errorLevel);
          }

          if (this.dataNameTooltipErrorNameDict[dataName] !== undefined) {
            const errorName = this.dataNameTooltipErrorNameDict[dataName];
            this[errorName] = stationData[dataId].errorLevel;
          }

          if (this.malfunctionDataNameErrorNameDict[dataName] !== undefined) {
            const errorName = this.malfunctionDataNameErrorNameDict[dataName];
            if (this[errorName] === "" && stationData[dataId].value && stationData[dataId].value > 0) {
              this[errorName] = "Error";
            }
          }
        }
      }
    },
    getAllowedMax() {
      let stationMetaRequestList = [];
      this.stationIdList.forEach((stationId) => {
        stationMetaRequestList.push(this.$http.get(`/bridge/StationInfo?stationId=${stationId}`));
      });

      this.$http.all(stationMetaRequestList).then(
        this.$http.spread((...resList) => {
          resList.forEach((res) => {
            this.setAllowedMax(res.data);
          });
        })
      );
    },
    setAllowedMax(stationData) {
      let deviceIdDevicedict = {};
      if (stationData.deviceList) {
        stationData.deviceList.forEach((item) => {
          deviceIdDevicedict[item.deviceId] = item;
        });
      }

      for (let allowedMaxName in this.allowedMaxNameIdDict) {
        const dataId = this.allowedMaxNameIdDict[allowedMaxName];
        if (deviceIdDevicedict[dataId] !== undefined) {
          let device = deviceIdDevicedict[dataId];
          this[allowedMaxName] = device.allowedMax;
        }
      }
    },
    getErrorLevelFromMultipleDevice(newErrorLevel, currentErrorLevel) {
      if (currentErrorLevel === "Error") {
        return "Error";
      } else if (currentErrorLevel === "Warning") {
        if (newErrorLevel === "Error") {
          return "Error";
        } else {
          return "Warning";
        }
      } else {
        return newErrorLevel;
      }
    },
    resetError() {
      for (let dataName in this.dataNameIdDict) {
        if (this.dataNameErrorNameDict[dataName] !== undefined) {
          const errorName = this.dataNameErrorNameDict[dataName];
          this[errorName] = "";
        }

        if (this.dataNameTooltipErrorNameDict[dataName] !== undefined) {
          const errorName = this.dataNameTooltipErrorNameDict[dataName];
          this[errorName] = "";
        }
      }
    },
    assembleTooltip_sensor(name, errorLevel, allowedMax) {
      let result = "";
      if (name) {
        result += name + ": ";
      }

      if (errorLevel.toLowerCase() === "normal") {
        result += "湿度正常";
      } else if (errorLevel.toLowerCase() === "warning") {
        result += "数据中断";
      } else if (errorLevel.toLowerCase() === "error") {
        result += "湿度超限";
      }

      if (
        (errorLevel.toLowerCase() === "normal" || errorLevel.toLowerCase() === "error") &&
        allowedMax !== undefined &&
        allowedMax !== null &&
        !isNaN(parseInt(allowedMax))
      ) {
        if (allowedMax === 0) {
          result += "(无限制)";
        } else {
          result += "(<" + allowedMax + "%RH)";
        }
      }

      return result;
    },
    assembleTooltip_dehumidifier(name, errorLevel, allowedMax, runningFlag, errorFlag) {
      let result = "";
      if (name) {
        result += name + ": ";
      }

      if (errorLevel.toLowerCase() === "normal") {
        result += "湿度正常";
      } else if (errorLevel.toLowerCase() === "warning") {
        result += "数据中断";
      } else if (errorLevel.toLowerCase() === "error") {
        result += "湿度超限";
      }

      if ((errorLevel.toLowerCase() === "normal" || errorLevel.toLowerCase() === "error") && allowedMax && !isNaN(parseInt(allowedMax))) {
        result += "(<" + allowedMax + "%RH)";
      }

      if (errorLevel.toLowerCase() !== "warning") {
        if (runningFlag > 0) {
          result += ", 除湿机运行";
        } else if (runningFlag === 0) {
          result += ", 除湿机停止";
        }
      }

      if (errorFlag > 0) {
        result += ", 故障报警";
      }

      return result;
    },
  },
};
</script>

<style lang="scss" scoped>
@keyframes breathee-warning {
  0% {
    border-color: rgba(255, 255, 0, 0.3);
  }
  100% {
    border-color: #ffff00;
    // background: rgba(255, 255, 255, 0.7);
  }
}
@keyframes breathee-error {
  0% {
    border-color: rgba(255, 0, 0, 0.3);
  }
  100% {
    border-color: #ff0000;
    // background: rgba(255, 255, 255, 0.7);
  }
}

.tooltip-slot {
  line-height: 1.4;
}

.gas-clamp {
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  height: calc(100% - 20px) !important;
  // min-height: 630px !important;

  .main-cable {
    width: 100%;
    height: 48%;
    padding: 0;
    display: flex;
    justify-content: flex-start;
    align-items: stretch;
    min-height: 370px;

    .cable-title {
      width: 50px;
      text-align: center;
      display: flex;
      background-color: #fff;
      justify-content: center;
      align-items: center;

      h2 {
        padding: 0 10px;
        font-weight: bold;
        font-size: 32px;
        line-height: 35px;
        color: #515151;
      }
    }

    .cable-main {
      position: relative;
      min-width: 1405px;
      width: calc(100% - 50px);
      background: linear-gradient(#ceeaf0, #e9f1ef);
      display: flex;
      justify-content: center;
      align-items: center;

      .legend {
        position: absolute;
        left: 75px;
        top: 25px;
        div {
          padding-left: 30px;
          height: 20px;
          margin-bottom: 10px;
          line-height: 20px;
          font-size: 14px;
          color: #515151;
          position: relative;
          &:after {
            position: absolute;
            left: 0;
            top: 0;
            content: " ";
            overflow: hidden;
            display: block;
            height: 20px;
            width: 20px;
            border-radius: 10px;
          }
        }
        .sensor1:after {
          background: #c7798b;
        }
        .sensor2:after {
          background: #3376c7;
        }
        .sensor-source {
          margin-left: -35px;
        }
      }
      .legend-right {
        position: absolute;
        right: 70px;
        top: 50px;
        div {
          padding-left: 30px;
          height: 20px;
          margin-bottom: 10px;
          line-height: 20px;
          font-size: 14px;
          color: #515151;
          position: relative;
          &:after {
            position: absolute;
            left: 0;
            top: 0;
            content: " ";
            overflow: hidden;
            display: block;
            height: 20px;
            width: 20px;
            border-radius: 10px;
          }
        }
        .default:after {
          background: #ffff00;
        }
        .running:after {
          background: #67dd34;
        }
        .stopped:after {
          background: #a0a0a0;
        }
      }
      .legend-station {
        position: absolute;
        left: -32px;
        top: 0px;

        i {
          font-size: 24px;
          color: #ed6a5a;
        }
        span {
          padding-left: 8px;
          bottom: 3px;
          margin-bottom: 10px;
          line-height: 20px;
          font-size: 14px;
          color: #515151;
          position: relative;
        }
      }

      .dir {
        position: absolute;
        top: 50px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        color: #2a387a;
        i {
          font-size: 30px;
        }
        .dir-text {
          font-size: 20px;
        }
      }
      .left-dir {
        left: 250px;
      }
      .right-dir {
        flex-direction: row-reverse;
        right: 250px;
      }
      .cable-img {
        position: relative;
        z-index: 0;
        width: 1400px;
        height: 250px;
        background-position: 50%;
        background-repeat: no-repeat;
        background-size: contain;
        background-image: url("../../assets/image/jinshajiang/bridgeLine.png");
        background-position-y: 100%;

        .station-block {
          position: absolute;
          color: #ed6a5a;
          font-size: 24px;
          text-decoration: none;
        }

        .station-block-left {
          top: 122px;
          left: 173px;
        }

        .station-block-middle {
          top: 122px;
          left: 582px;
        }

        .station-block-right {
          top: 122px;
          left: 990px;
        }

        .stati {
          position: absolute;
          &:before,
          &:after {
            position: absolute;
            display: block;
            content: "";
            height: 2px;
            background: #ed6a5a;
          }
          &:before {
            width: 50px;
          }
          &:after {
            width: 15px;
          }
          .state-info {
            font-size: 14px;
            line-height: 17px;
            color: #515151;
            text-align: right;
            min-width: 75px;
            transform: translateY(-50%);
            position: absolute;
            text-decoration: none;
            border-radius: 10px;
            box-sizing: border-box;
            padding: 6px 8px 6px 6px;
            border: 2px solid transparent;
            box-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
            background-color: rgba(246, 250, 255, 0.9);
            &:before {
              background-color: #ed6a5a;
            }
            & > p {
              margin: 0;
              white-space: nowrap;
              white-space: nowrap;
              display: flex;
              justify-content: space-between;
              align-items: baseline;
              &:first-child {
                font-size: 13px;
              }
            }
            &.right-pos:before {
              right: 0;
              transform: translate(50%, -50%);
            }
            &.left-pos:before {
              left: -8px;
              transform: translate(50%, -50%);
            }
            &.bottom-pos-sta:before {
              left: 50%;
              top: 95%;
              transform: translate(0%, 0%);
            }
            &.bottom-right-pos:before {
              left: 83%;
              top: 95%;
              transform: translate(0%, 0%);
            }
            &.bottom-left-pos:before {
              left: 17%;
              top: 95%;
              transform: translate(0%, 0%);
            }
            &:before {
              position: absolute;
              display: block;
              content: "";
              height: 8px;
              width: 8px;
              border-radius: 4px;
              top: 50%;
            }

            .valve-sign {
              margin-top: auto;
              margin-bottom: auto;
              width: 12px;
              height: 12px;
              background-color: #ffff00;
              animation: breathee-valve-sign-default 1500ms infinite alternate ease-in-out;
              border-radius: 10px;
              margin-left: 12px;

              &.running {
                background-color: #67dd34;
                animation: none;
              }
              &.stopped {
                background-color: #a0a0a0;
                animation: none;
              }
            }
          }
          .Warning {
            border-color: #ffff00;
            animation: breathee-warning 1500ms infinite alternate ease-in-out;
          }
          .Error {
            border-color: #ff0000;
            animation: breathee-error 1500ms infinite alternate ease-in-out;
          }
        }

        .clip {
          position: absolute;
          width: 16px;
          height: 16px;
          border-radius: 8px;
          &:before,
          &:after {
            position: absolute;
            display: block;
            content: "";
            height: 2px;
          }
          &:before {
            width: 50px;
          }
          &:after {
            width: 15px;
          }
          .state-info {
            font-size: 14px;
            line-height: 17px;
            color: #515151;
            text-align: right;
            min-width: 75px;
            transform: translateY(-50%);
            position: absolute;
            border-radius: 10px;
            box-sizing: border-box;
            padding: 6px 8px 6px 6px;
            border: 2px solid transparent;
            box-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
            & > p {
              margin: 0;
              white-space: nowrap;
              &:first-child {
                font-size: 13px;
              }
            }
            &.right-pos:before {
              right: 0;
              transform: translate(50%, -50%);
            }
            &.left-pos:before {
              left: -8px;
              transform: translate(50%, -50%);
            }
            &.bottom-pos:before {
              left: 45%;
              top: 90%;
              transform: translate(0%, 0%);
            }
            &.top-pos:before {
              left: 46.5%;
              top: -5%;
              transform: translate(0%, 0%);
            }
            &.top-right-pos:before {
              left: 66.5%;
              top: -5%;
              transform: translate(0%, 0%);
            }
            &.top-right-pos-2:before {
              left: 81.5%;
              top: -5%;
              transform: translate(0%, 0%);
            }
            &.top-left-pos:before {
              left: 20%;
              top: -5%;
              transform: translate(0%, 0%);
            }
            &.top-left-pos-2:before {
              left: 13.5%;
              top: -5%;
              transform: translate(0%, 0%);
            }
            &:before {
              position: absolute;
              display: block;
              content: "";
              height: 8px;
              width: 8px;
              border-radius: 4px;
              top: 50%;
            }
          }
          .Warning {
            border-color: #ffff00;
            animation: breathee-warning 1500ms infinite alternate ease-in-out;
          }
          .Error {
            border-color: #ff0000;
            animation: breathee-error 1500ms infinite alternate ease-in-out;
          }
          &.sensor1 {
            background: #c7798b;
            &:after,
            &:before {
              background: #c7798b;
            }
            .state-info {
              background-color: rgba(246, 250, 255, 0.9);
              &:before {
                background-color: #c7798b;
              }
            }
          }
          &.sensor2 {
            background: #3376c7;
            &:after,
            &:before {
              background: #3376c7;
            }
            .state-info {
              background-color: rgba(246, 250, 255, 0.9);
              &:before {
                background-color: #3376c7;
              }
            }
          }
        }

        .sta-left {
          top: 130px;
          left: 173px;
          &::before {
            bottom: 30px;
            left: -35px;
            width: 80px;
            transform: rotate(80deg);
          }
          &::after {
            bottom: 69px;
            left: -16px;
          }
          .state-info {
            right: 16px;
            top: -69px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 110px;
          }
        }

        .sta-left-tower {
          top: 130px;
          left: 173px;
          &::before {
            bottom: 30px;
            left: -22px;
            width: 80px;
            transform: rotate(100deg);
          }
          &::after {
            bottom: 69px;
            left: 24px;
          }
          .state-info {
            right: -149px;
            top: -69px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 110px;
          }
        }

        .sta-middle {
          top: 130px;
          left: 582px;
          &::before {
            bottom: 30px;
            left: -35px;
            width: 80px;
            transform: rotate(80deg);
          }
          &::after {
            bottom: 69px;
            left: -16px;
          }
          .state-info {
            right: 16px;
            top: -69px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 110px;
          }
        }

        .sta-middle-tower {
          top: 130px;
          left: 582px;
          &::before {
            bottom: 30px;
            left: -22px;
            width: 80px;
            transform: rotate(100deg);
          }
          &::after {
            bottom: 69px;
            left: 24px;
          }
          .state-info {
            right: -149px;
            top: -69px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 110px;
          }
        }

        .sta-right {
          top: 130px;
          left: 990px;
          &::before {
            bottom: 30px;
            left: -35px;
            width: 80px;
            transform: rotate(80deg);
          }
          &::after {
            bottom: 69px;
            left: -16px;
          }
          .state-info {
            right: 16px;
            top: -69px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 110px;
          }
        }

        .sta-right-tower {
          top: 130px;
          left: 990px;
          &::before {
            bottom: 30px;
            left: -22px;
            width: 80px;
            transform: rotate(100deg);
          }
          &::after {
            bottom: 69px;
            left: 24px;
          }
          .state-info {
            right: -149px;
            top: -69px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 110px;
          }
        }

        .station-block-anchor-left {
          top: 143px;
          left: 218px;
        }

        .station-block-anchor-right {
          top: 143px;
          left: 1197px;
        }

        .station-block-saddle-left {
          top: 65px;
          left: 380px;
        }

        .station-block-saddle-right {
          top: 65px;
          left: 968px;
        }

        .anchor-left {
          top: 153px;
          left: 218px;
          &::before {
            top: 43px;
            left: -50px;
            width: 90px;
            transform: rotate(-69deg);
          }
          &::after {
            top: 84px;
            left: -36px;
          }
          .state-info {
            right: 30px;
            top: 85px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 110px;
          }
        }

        .anchor-right {
          top: 153px;
          left: 1227px;
          &::before {
            top: 41px;
            left: -52px;
            width: 90px;
            transform: rotate(74deg);
          }
          &::after {
            top: 84px;
            left: 6px;
          }
          .state-info {
            right: -140px;
            top: 85px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 110px;
          }
        }

        .saddle-left {
          top: 80px;
          left: 380px;

          &::before {
            top: -30px;
            left: -18px;
            width: 60px;
            transform: rotate(90deg);
          }

          &::after {
            top: -67px;
            left: -28px;
            width: 0px;
          }

          .state-info {
            right: -30px;
            top: -85px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 110px;
          }
        }

        .saddle-right {
          top: 80px;
          left: 969px;

          &::before {
            top: -30px;
            left: -19px;
            width: 60px;
            transform: rotate(90deg);
          }

          &::after {
            top: -67px;
            left: -28px;
            width: 0px;
          }

          .state-info {
            right: -107px;
            top: -85px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 110px;
          }
        }

        .ex1 {
          top: 152px;
          left: 200px;
          &::before {
            top: -34px;
            left: -33px;
            width: 70px;
            transform: rotate(79deg);
          }
          &::after {
            top: -68px;
            left: -19px;
          }
          .state-info {
            right: 37px;
            top: -66px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 110px;
          }
        }

        .ex2 {
          top: 120px;
          left: 285px;
          &::before {
            top: 50px;
            left: -32px;
            width: 80px;
            transform: rotate(270deg);
          }

          &::after {
            top: 138px;
            left: -5px;
            width: 0px;
          }

          .state-info {
            right: -26px;
            top: 120px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 110px;
          }
        }

        .ex3 {
          top: 81px;
          left: 370px;

          &::before {
            top: -6px;
            left: -10px;
            width: 30px;
            transform: rotate(79deg);
          }

          &::after {
            top: -20px;
            left: -13px;
          }

          .state-info {
            right: 28px;
            top: -18px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 110px;
          }
        }

        .ex4 {
          top: 81px;
          left: 399px;
          &::before {
            bottom: 48px;
            left: -20px;
            width: 70px;
            transform: rotate(-79deg);
          }

          &::after {
            bottom: 82px;
            left: 22px;
          }

          .state-info {
            right: -130px;
            top: -66px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 110px;
          }
        }

        .ex5 {
          top: 100px;
          left: 455px;
          &::before {
            top: 60px;
            left: -42px;
            width: 100px;
            transform: rotate(270deg);
          }

          &::after {
            top: 138px;
            left: -32px;
            width: 20px;
            width: 0px;
          }

          .state-info {
            right: -26px;
            top: 140px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 110px;
          }
        }

        .ex6 {
          top: 120px;
          left: 524px;
          &::before {
            bottom: 48px;
            left: -20px;
            width: 70px;
            transform: rotate(-79deg);
          }

          &::after {
            bottom: 82px;
            left: 22px;
          }

          .state-info {
            right: -130px;
            top: -66px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 110px;
          }
        }

        .ex7 {
          top: 134px;
          left: 604px;
          &::before {
            top: 42px;
            left: -22px;
            width: 60px;
            transform: rotate(270deg);
          }

          &::after {
            top: 111px;
            left: -26px;
            width: 0px;
          }

          .state-info {
            right: -10px;
            top: 106px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 110px;
          }
        }

        .ex8 {
          top: 140px;
          left: 686px;
          &::before {
            top: 20px;
            left: -6px;
            width: 28px;
            transform: rotate(270deg);
          }

          &::after {
            display: none;
            left: 21px;
          }

          .state-info {
            left: 7px;
            top: 35px;
            transform: translateX(-49%);
            // 在数据为空时维持宽度, 以免断连
            min-width: 110px;
          }
        }

        .ex9 {
          top: 130px;
          left: 769px;
          &::before {
            top: 45px;
            left: -22px;
            width: 60px;
            transform: rotate(270deg);
          }

          &::after {
            top: 120px;
            left: -26px;
            width: 0px;
          }

          .state-info {
            right: -82px;
            top: 110px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 110px;
          }
        }

        .ex10 {
          top: 121px;
          left: 835px;
          &::before {
            bottom: 48px;
            right: -18px;
            width: 70px;
            transform: rotate(79deg);
          }

          &::after {
            top: -68px;
            left: -22px;
          }

          .state-info {
            right: 35px;
            top: -66px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 110px;
          }
        }

        .ex11 {
          top: 100px;
          left: 910px;
          &::before {
            top: 60px;
            left: -42px;
            width: 100px;
            transform: rotate(270deg);
          }

          &::after {
            top: 138px;
            left: -32px;
            width: 20px;
            width: 0px;
          }

          .state-info {
            right: -75px;
            top: 140px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 110px;
          }
        }
        .ex12 {
          top: 81px;
          left: 958px;

          &::before {
            top: -33px;
            left: -38px;
            width: 70px;
            transform: rotate(71deg);
          }

          &::after {
            top: -67px;
            left: -28px;
          }

          .state-info {
            right: 41px;
            top: -66px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 110px;
          }
        }

        .ex13 {
          top: 81px;
          left: 988px;
          &::before {
            top: -8px;
            left: -5px;
            width: 30px;
            transform: rotate(101deg);
          }

          &::after {
            top: -22px;
            left: 13px;
          }

          .state-info {
            right: -122px;
            top: -20px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 110px;
          }
        }

        .ex14 {
          top: 118px;
          left: 1090px;
          &::before {
            top: 50px;
            left: -32px;
            width: 80px;
            transform: rotate(270deg);
          }

          &::after {
            top: 138px;
            left: -5px;
            width: 0px;
          }

          .state-info {
            right: -75px;
            top: 120px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 110px;
          }
        }

        .ex15 {
          top: 155px;
          left: 1220px;
          &::before {
            top: -34px;
            right: -35px;
            width: 70px;
            transform: rotate(-79deg);
          }

          &::after {
            top: -68px;
            right: -21px;
          }

          .state-info {
            left: 39px;
            top: -66px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 110px;
          }
        }
      }
    }
  }
}
</style>
